import React, { useEffect, useState } from "react";
import { Avatar, Box, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, InputLabel, Tab, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { makeStyles } from "tss-react/mui";
import ProfileTable from "./ProfileDetails";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTheme } from "@emotion/react";
import CloseIcon from '@mui/icons-material/Close';
import {
    getAvailableAccess,
    getDocumentsById,
    getMembersSummary,
    id_proof_verification,
    updateMember,
    uploadImage,
} from "../../Redux/Actions/action";
import { useDispatch } from "react-redux";
import ErrorHandler, {
    calculateAgeAndMonth,
    checkAccess,
    formattedDate,
    getFileIcon,
    getImageUrl,
    getLabelbyId,
    getValuebyId,
} from "../../Utils/handler";
import { showLoader } from "../../Redux/Slices/loaderSlice";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";

import AadharCard from "./AadharCard";

import DobCertification from "./DobCertification";
import FinalizeDocuments from "./Finalize";
import sessionStoreUtil from "../../ApiSetup/Localstorage";
import { Regex } from "../../Utils/regex";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import IdProof from "./IdProof";
import AddressProof from "./AddressProof";
import AppRegistrationTwoToneIcon from "@mui/icons-material/AppRegistrationTwoTone";
import {
    additionalDocumentTypeList,
    addressProofTypes,
    castTypes,
    idProofTypes,
    relationList,
} from "../../Utils/enum";
import AdditionalDocument from "./AddtionalDocument";
import TextLabel from "../Common/CommonTextLabel";
import { BucketURL } from "../../ApiSetup/Api";
import DocPreview from "../Common/DocPreview";
import { DocWithPreview } from "../Common/DocWithPreview";
import ButtonOutlined from "../Common/ButtonOutlined";
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import ButtonContained from "../Common/ButtonContained";
import CommonTextArea from "./CommonTextArea";
const useStyles = makeStyles()((theme) => {
    return {
        gridBorder: {
            background: "#fff",
            border: "1px solid #e8e8e8",
            padding: "20px",
            borderRadius: "16px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        },
        label: {
            fontSize: "12px",
            fontWeight: 500,
            color: "#888",
            marginBottom: "4px",
            textTransform: "uppercase",
            letterSpacing: "0.3px",
        },
        TabList: {
            color: "#FFFFFF !important",
            "& .MuiTabs-indicator": {
                display: "none",
            },
            "& .Mui-selected": {
                // backgroundColor: "#3E4094",
                color: "#FFFFFF !important",
                borderBottom: "3px solid white",
                // backgroundColor: "#3E4094",
                // borderRadius: "6px"
            },
            // "& .MuiTabs-flexContainer": {
            //     display: "flex",
            //     justifyContent: "space-between",
            // },
            // "& .MuiTab-root": {
            //     color: "#FFFFFF !important",
            //     textTransform: "capitalize",
            //     flex: 1,
            //     borderRight: "1px solid #3E4094",
            //     ":last-of-type": {
            //         // borderRight: "none",
            //         borderRadius: "0 6px 6px 0"
            //     },
            //     ":first-of-type": {
            //         borderRadius: "6px 0 0 6px",
            //     },
            //     "&.Mui-selected:first-of-type": {
            //         borderRadius: "6px 0 0 6px",
            //     },
            //     display: "flex",
            //     alignItems: "center",
            //     gap: "8px",
            // },
        },
        TabDesign: {
            backgroundColor: "transparent",
            borderRadius: "6px",
            color: "#3E4094",
            minHeight: "40px",
            maxHeight: "50px",
            minWidth: "auto",
            "&.Mui-selected": {
                backgroundColor: "#3E4094",
            },
        },
    };
});

const DocumentsView = () => {
    // ---------- Hook -----------
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme()
    const { classes } = useStyles();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id"); // gets the id
    const searchText = queryParams.get("searchText"); // gets the searchText
    const user = sessionStoreUtil.getLSItem("userData")
        ? JSON.parse(sessionStoreUtil.getLSItem("userData"))
        : {};
    const dataAccess = useSelector((value) => value?.allAvailableAccess?.AllAvailableAccessList);
    const { pathname } = useLocation();

    const startPathname = pathname?.split('-')[0];

    // --------------- State -------------
    const [value, setValue] = useState("1");
    const [document, setDocument] = useState(null);
    const [imagePreView, setImagePreView] = useState({ isOpen: false, link: "" });
    const [data, setData] = useState({});
    const [preview, setPreview] = React.useState({ open: false, link: "", fileName: "" });
    const [isEdit, setIsEdit] = useState({
        aadharCard: false,
        panCard: false,
        lc_dob_certificate: false,
        otherDocument: false,
        additionalDocument: false
    });
    const [errors, setErrors] = useState({});
    // ----- AadharCard -----
    const [openFrontSide, setOpenFrontSide] = useState(false);
    const [openBackSide, setOpenBackSide] = useState(false);
    // ----- IdProof -----
    const [openIdProof, setOpenIdProof] = useState(false);
    // ----- DobCertification -----
    const [openDobCertification, setOpenDobCertification] = useState(false);
    // ----- AddressProof -----
    const [openAddressProof, setOpenAddressProof] = useState(false);
    // ----- Additional Document -----
    const [openAdditionalDocument, setOpenAdditionalDocument] = useState(false);

    // --------------- handleChange ---------------
    const handleInputChange = (e, parentKey) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [parentKey]: {
                ...prevData[parentKey],
                [name]: value,
            },
        }));
    };

    const handleChange = ({ target: { name, value }, section }) => {
        if (name === "aadharCardNumber" && value.length > 12) return;
        if (name === "panCardNumber") {
            value = value.toUpperCase();
        }
        setData((prevData) => ({
            ...prevData,
            uploadDocuments: {
                ...prevData.uploadDocuments,
                [section]: {
                    ...prevData.uploadDocuments[section], // Preserve other fields in the section
                    [name]: value, // Update only the specific field
                },
            },
        }));
    };

    const handleFilterChange = (date, { target: { name }, section }) => {
        setData((prevData) => ({
            ...prevData,
            uploadDocuments: {
                ...prevData.uploadDocuments,
                [section]: {
                    ...prevData.uploadDocuments[section],
                    [name]: date ? dayjs(date).format("DD/MM/YYYY") : null, // Format and update the field
                },
            },
        }));
    };

    const handleStatusChange = (keyName, parentKey, statusValue) => {
        setData((prevData) => {
            if (parentKey) {
                // Toggle the status value
                const currentStatus = prevData[parentKey]?.[keyName];
                const newStatus = currentStatus === statusValue ? null : statusValue;

                return {
                    ...prevData,
                    [parentKey]: {
                        ...prevData[parentKey],
                        [keyName]: newStatus,
                        ...(newStatus === null ? { reason: "" } : {}),
                    },
                };
            } else {
                const currentStatus = prevData[keyName];
                const newStatus = currentStatus === statusValue ? null : statusValue;

                return {
                    ...prevData,
                    [keyName]: newStatus,
                };
            }
        });
    };

    const handleUpload = async (e, parentKey, childKey = null) => {
        const { files, name } = e?.target;

        if (!files || files?.length === 0) {
            toast?.error("No files selected for upload.");
            return;
        }

        const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"]; // Including webp if supported
        const maxFileSize = 5242880; // 5 MB
        const invalidFiles = [];

        // Validate files
        for (let file of files) {
            if (!validTypes?.includes(file?.type) || file?.size > maxFileSize) {
                invalidFiles?.push(file?.name);
            }
        }

        if (invalidFiles.length > 0) {
            toast?.error(`Invalid files detected: ${invalidFiles?.join(", ")}.`);
            return;
        }

        dispatch(showLoader(true));

        try {
            const formData = new FormData();
            // Append all valid files
            Array.from(files)?.forEach((file) => formData?.append("image", file));

            // Dispatch single API call for multiple files
            const result = await dispatch(uploadImage(formData));

            // Handle response
            const error = ErrorHandler(result);
            const uploadedImages = error ? result?.payload?.data : null;
            if (uploadedImages && uploadedImages?.length > 0) {
                setData((prevState) => {
                    const newImages = uploadedImages?.map((img) => img?.image);

                    if (childKey) {
                        return {
                            ...prevState,
                            [parentKey]: {
                                ...prevState[parentKey],
                                [childKey]: {
                                    ...prevState[parentKey][childKey],
                                    [name]: newImages,
                                },
                            },
                        };
                    } else {
                        return {
                            ...prevState,
                            [parentKey]: {
                                ...prevState[parentKey],
                                [name]: newImages,
                            },
                        };
                    }
                });
                setOpenFrontSide(false);
                setOpenBackSide(false);
                setOpenIdProof(false);
                setOpenDobCertification(false);
                setOpenAddressProof(false);
                setOpenAdditionalDocument(false)
            } else {
                toast?.error("No files were successfully uploaded.");
            }
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    const validation = () => {
        const errors = {};
        let valid = true;
        if (data?.permanentDisable) {
            if (!data?.permanentDisableReason) {
                errors.permanentDisableReason =
                    "* Please enter your reason for Permanent Disable !";
                valid = false;
            }
        }

        if (!data?.isAgree) {
            errors.isAgree = "* Please select agree with process to continue.. !";
            valid = false;
        }

        setErrors(errors);
        return valid;
    };

    // --------------- Api ---------------
    const _getDocumetsData = async (id) => {
        dispatch(showLoader(true));
        try {
            const result = await dispatch(getDocumentsById(`/${id}`));
            const error = ErrorHandler(result);
            if (error) {
                const {
                    _id,
                    nomineeDetails,
                    documentVerificationStatus,
                    verificationStatus,
                    permanentDisableReason,
                    permanentDisable,
                    personalDetails,
                } = result?.payload?.data.response;

                setDocument({
                    nomineeDetails: nomineeDetails?.map((e) => ({ ...e, relation: getLabelbyId(e?.relation, relationList), })),
                    _id: _id,
                    ...result?.payload?.data.response
                });
                setData({
                    personalDetails: personalDetails,
                    verificationStatus: verificationStatus,
                    aadharCard: {
                        status: documentVerificationStatus?.aadharCard?.status || "",
                        reason: documentVerificationStatus?.aadharCard?.reason || "",
                    },
                    addressProof: {
                        status: documentVerificationStatus?.addressProof?.status || "",
                        reason: documentVerificationStatus?.addressProof?.reason || "",
                    },
                    idProof: {
                        status: documentVerificationStatus?.idProof?.status || "",
                        reason: documentVerificationStatus?.idProof?.reason || "",
                    },
                    isAgree: documentVerificationStatus?.isAgree || false,
                    verifiedBy: user?._id,
                    permanentDisable: permanentDisable,
                    permanentDisableReason: permanentDisableReason || "",
                });
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };
    const _updateMember = async (tab) => {
        dispatch(showLoader(true));
        try {
            let body = {
                _id: id,
                permanentDisable: data?.permanentDisable || false,
                permanentDisableReason: data?.permanentDisable ? data?.permanentDisableReason : "",
                documentVerificationStatus: {
                    aadharCard: {
                        status: (data?.verificationStatus == "Rejected" && !data?.permanentDisable) ? "Approved" : data?.permanentDisable ? "Rejected" : data?.aadharCard?.status || "Approved",
                        reason: data?.aadharCard?.status !== "Approved" ? data?.aadharCard?.reason : "",
                    },
                    addressProof: {
                        status: (data?.verificationStatus == "Rejected" && !data?.permanentDisable) ? "Approved" : data?.permanentDisable ? "Rejected" : data?.addressProof?.status || "Approved",
                        reason: data?.addressProof?.status !== "Approved" ? data?.addressProof?.reason : "",
                    },
                    idProof: {
                        status: (data?.verificationStatus == "Rejected" && !data?.permanentDisable) ? "Approved" : data?.permanentDisable ? "Rejected" : data?.idProof?.status || "Approved",
                        reason: data?.idProof?.status !== "Approved" ? data?.idProof?.reason : "",
                    },
                    isAgree: data?.isAgree || false,
                    verifiedBy: user?._id,
                },
            };

            const result = await dispatch(updateMember(body));
            const error = ErrorHandler(result);
            if (error) {
                window.history.back();
                if (tab) {
                    setValue(tab);
                    await _getDocumetsData(id);
                    toast.success("Details upldated successfully. !");
                }
            }
        } catch (error) {
            toast.error(error?.message || "An unknown error occurred");
        } finally {
            dispatch(showLoader(false));
        }
    };


    const _id_proof_verification = async () => {
        const body = { idProofType: document?.idProofDetails?.idProofType, idProofValue: document?.idProofDetails?.idProofValue, date_of_birth: dayjs(document?.personalDetails?.dateOfBirth).format("YYYY-MM-DD"), userId: document?._id };
        dispatch(showLoader(true));
        try {
            const result = await dispatch(id_proof_verification(body));
            const error = ErrorHandler(result);
            if (error) {
                toast?.success(result?.payload?.message);
                _getDocumetsData(id);
            }
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    // -------- useEffect ----------
    useEffect(() => {
        if (id) {
            _getDocumetsData(id);
        }
    }, [id]);

    useEffect(() => {
        dispatch(showLoader(true));
        dispatch(getAvailableAccess())
            .unwrap() // Automatically handles async response
            .catch((error) => console.error("error", error))
            .finally(() => dispatch(showLoader(false)));
    }, [dispatch]);

    return (
        <Grid container item xs={12} paddingLeft={2}>
            <Box sx={{ width: "100%", typography: "body1" }}>
                <Box display={"flex"} gap={3} alignItems={"center"} justifyContent={"space-between"} mb={3}>
                    <Box display={"flex"} gap={3} alignItems={"center"}>
                        <ArrowBackIcon
                            sx={{ cursor: "pointer" }}
                            onClick={() => { searchText ? navigate(`/admin/memberSearch?searchText=${searchText}`) : window.history.back() }}
                        />
                        <Typography sx={{ fontSize: { lg: 26, md: 20, xs: 18 } }}>
                            Document Verifications
                        </Typography>
                    </Box>
                    {(user?.loginRole === "SuperAdmin" || checkAccess(startPathname, dataAccess, 'Personal Detail Edit')) && (
                        <Box textAlign={"end"}>
                            <IconButton sx={{ padding: "0px !important" }} onClick={() => !document?.personalDetails?.aadhaarNumber ? navigate(`/admin/addMember`) : navigate(`/admin/addMember?id=${document?._id}&memberEdit=${true}&step=0`)}>
                                <AppRegistrationTwoToneIcon fontSize="large" color="primary" />
                            </IconButton>
                        </Box>
                    )}
                </Box>


                {/* ---------- TabPanel 1 ----------- */}
                {/* <TabPanel value="1" sx={{ padding: "0px !important", my: 3 }}> */}

                {/* <Grid container item xs={12} spacing={2}>
                    <Grid item xs={12} sm={6} md={6} lg={6} className={classes.gridBorder}>
                    
                        <Divider flexItem sx={{ m: "10px 0px" }} />
                        <IdProof
                            data={data}
                            setData={setData}
                            setImagePreView={setImagePreView}
                            handleStatusChange={handleStatusChange}
                            _updateMember={_updateMember}
                            handleInputChange={handleInputChange}
                            setValue={setValue}
                            handleChange={(e) => handleChange({ ...e, section: "panCard" })}
                            errors={errors}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            dataAccess={dataAccess}
                            handleUpload={handleUpload}
                            openIdProof={openIdProof}
                            setOpenIdProof={setOpenIdProof}
                        />
                        <Divider flexItem sx={{ m: "10px 0px" }} />
                        <DobCertification
                            data={data}
                            setData={setData}
                            setImagePreView={setImagePreView}
                            handleStatusChange={handleStatusChange}
                            _updateMember={_updateMember}
                            handleInputChange={handleInputChange}
                            setValue={setValue}
                            handleChange={(e) => handleChange({ ...e, section: "lc_dob_certificate" })}
                            errors={errors}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            dataAccess={dataAccess}
                            handleUpload={handleUpload}
                            openDobCertification={openDobCertification}
                            setOpenDobCertification={setOpenDobCertification}
                        />
                        <Divider flexItem sx={{ m: "10px 0px" }} />
                        <AddressProof
                            data={data}
                            setData={setData}
                            setImagePreView={setImagePreView}
                            handleStatusChange={handleStatusChange}
                            _updateMember={_updateMember}
                            handleInputChange={handleInputChange}
                            setValue={setValue}
                            handleChange={(e) => handleChange({ ...e, section: "otherDocument" })}
                            errors={errors}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            dataAccess={dataAccess}
                            handleUpload={handleUpload}
                            openAddressProof={openAddressProof}
                            setOpenAddressProof={setOpenAddressProof}
                        />
                        <Divider flexItem sx={{ m: "10px 0px" }} />
                        <AdditionalDocument
                            data={data}
                            setData={setData}
                            setImagePreView={setImagePreView}
                            handleStatusChange={handleStatusChange}
                            _updateMember={_updateMember}
                            handleInputChange={handleInputChange}
                            setValue={setValue}
                            handleChange={(e) => handleChange({ ...e, section: "otherDocument" })}
                            errors={errors}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            dataAccess={dataAccess}
                            handleUpload={handleUpload}
                            openAdditionalDocument={openAdditionalDocument}
                            setOpenAdditionalDocument={setOpenAdditionalDocument}
                        />
                        <Divider flexItem sx={{ m: "10px 0px" }} />
                        <FinalizeDocuments
                            data={data}
                            handleStatusChange={handleStatusChange}
                            _updateMember={_updateMember}
                            validation={validation}
                            errors={errors}
                            dataAccess={dataAccess}
                        />
                        <Divider flexItem sx={{ m: "10px 0px" }} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ pt: { sm: "0px !important" }, pl: { xs: "0px !important", sm: "16px !important" }, }}>
                        <Box className={classes.gridBorder}>
                            {(user?.loginRole === "SuperAdmin" || checkAccess(startPathname, dataAccess, 'Personal Detail Edit')) && (
                                <Box textAlign={"end"}>
                                    <IconButton sx={{ padding: "0px !important" }} onClick={() => navigate(`/admin/addMember?id=${document?._id}&memberEdit=${true}&step=0`)}>
                                        <AppRegistrationTwoToneIcon fontSize="large" color="primary" />
                                    </IconButton>
                                </Box>
                            )}
                            <ProfileTable
                                aadharCard={document?.aadharCard}
                                personalDetails={document?.personalDetails}
                                generalDetails={document?.generalDetails}
                                nomineeDetails={document?.nomineeDetails}
                            />
                        </Box>
                    </Grid>
                </Grid> */}
                <Grid container spacing={2} className={classes.gridBorder}>
                    <Grid item xs={12} sm={12} md={12} lg={12} paddingTop={'2px !important'}>
                        <TextLabel fontSize={{ xs: "16px", md: "20px" }} padding={0} fontWeight={600} color='#3E4094' title={"Personal Detail"} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Box display={'flex'} alignItems={'center'} gap={2}>
                            <InputLabel className={classes.label}>Profile Image </InputLabel>
                            <Avatar 
                                src={getImageUrl(document?.personalDetails?.image)} 
                                alt={document?.personalDetails?.fullName || "Profile"} 
                                sx={{ 
                                    cursor: 'pointer',
                                    width: 56,
                                    height: 56,
                                    border: '2px solid #e0e0e0'
                                }}
                                onClick={() => setPreview({ 
                                    open: true, 
                                    link: getImageUrl(document?.personalDetails?.image), 
                                    fileName: document?.personalDetails?.image 
                                })}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Full Name </InputLabel>
                        <Typography variant="body1">{document?.personalDetails?.fullName || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Role </InputLabel>
                        <Typography variant="body1">{document?.personalDetails?.role || data?.userType || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Phone Number </InputLabel>
                        <Typography variant="body1">{document?.personalDetails?.phoneNumber || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Aadhaar Number </InputLabel>
                        <Typography variant="body1">{document?.personalDetails?.aadhaarNumber || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Date of Birth </InputLabel>
                        <Typography variant="body1">{dayjs(document?.personalDetails?.dateOfBirth).format("DD MMM YYYY") || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Gender </InputLabel>
                        <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>{document?.personalDetails?.gender || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Blood Group </InputLabel>
                        <Typography variant="body1">{document?.personalDetails?.bloodGroup || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Caste </InputLabel>
                        <Typography variant="body1">{document?.personalDetails?.caste || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Marital Status </InputLabel>
                        <Typography variant="body1">{document?.personalDetails?.maritalStatus || "N/A"}</Typography>
                    </Grid>

                    {document?.personalDetails?.aadhaarFrontSide && document?.personalDetails?.aadhaarBackSide &&
                        <AadharCard
                            data={data}
                            setImagePreView={setImagePreView}
                            handleStatusChange={handleStatusChange}
                            _updateMember={_updateMember}
                            handleInputChange={handleInputChange}
                            setValue={setValue}
                            handleChange={(e) => handleChange({ ...e, section: "aadharCard" })}
                            handleFilterChange={(date, e) => handleFilterChange(date, { ...e, section: "aadharCard" })}
                            errors={errors}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            dataAccess={dataAccess}
                            handleUpload={handleUpload}
                            openFrontSide={openFrontSide}
                            setOpenFrontSide={setOpenFrontSide}
                            openBackSide={openBackSide}
                            setOpenBackSide={setOpenBackSide}
                        />}
                </Grid>
                <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} paddingTop={'2px !important'}>
                        <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"ID Proof Details"} />
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>ID Proof Type</InputLabel>
                        <Typography variant="body1">{document?.idProofDetails?.idProofType || "N/A"}</Typography>
                    </Grid>

                    {document?.idProofDetails?.idProofValue && <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>ID Proof Number</InputLabel>
                        <Typography variant="body1">{document?.idProofDetails?.idProofValue || "N/A"}</Typography>
                    </Grid>}

                    {document?.isIdProofVerified && renderIDProof(document?.idProofDetails?.idProofType, classes, document?.idProofDetails)}

                    {document?.idProofDetails?.idProofImage?.length > 0 && <><Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box onClick={() => { setImagePreView({ isOpen: true, link: getImageUrl(document?.idProofDetails?.idProofImage) }); }}>
                            <DocWithPreview
                                docArray={document?.idProofDetails?.idProofImage ? document?.idProofDetails?.idProofImage : []}
                                docName={"ID Proof Image"}
                                title={"ID Proof"}
                            />
                        </Box>
                    </Grid>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>

                                    {checkAccess(startPathname, dataAccess, 'Accept/Reject Action') && data?.verificationStatus !== "Approved" &&
                                        <Box display={'flex'} alignItems={'center'} gap={1}>
                                            <ToggleButtonGroup
                                                color={data?.idProof?.status == "Approved" ? "success" : "error"}
                                                value={data?.idProof?.status}
                                                exclusive
                                                aria-label="Platform"
                                                size='small'

                                            >
                                                <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Approved" onClick={() => handleStatusChange("status", "idProof", "Approved")}>
                                                    {data?.idProof?.status == "Approved" ? "Approved" : "Approve"}</ToggleButton>
                                                <ToggleButton sx={{ borderRadius: '20px', width: '100px', fontWeight: 550 }} value="Rejected" onClick={() => handleStatusChange("status", "idProof", "Rejected")}>
                                                    {data?.idProof?.status == "Rejected" ? "Rejected" : "Reject"}</ToggleButton>
                                            </ToggleButtonGroup>
                                        </Box>
                                    }
                                    {
                                        checkAccess(startPathname, dataAccess, 'Accept/Reject Action') &&
                                        data?.verificationStatus == "Approved" && <ButtonOutlined
                                            width={"auto"}
                                            text={"Approved"}
                                            border={"1px dashed green"}
                                            color={'green'}
                                            borderRadius={'20px'}
                                            padding={{ xs: "5px 10px", md: "5px 10px" }}
                                            fontSize={{ xs: "12px", md: "14px" }}
                                            height={{ xs: "30px", sm: "30px", md: "30px" }}
                                            endIcon={<CheckCircleIcon />}
                                        />}
                                </Box>
                            </Grid>
                            {data?.verificationStatus !== "Approved" && data?.idProof?.status == "Rejected" && <Grid item xs={12}>
                                <CommonTextArea
                                    label="Reason"
                                    value={data?.idProof?.reason}
                                    labelSize={{ lg: "14px", md: "14px", xs: "12px" }}
                                    name='reason'
                                    onChange={(e) => handleInputChange(e, "idProof")}
                                    rows={2}
                                    disabled={user?.organisationName !== "PPSK"}
                                />
                            </Grid>}
                        </Grid></>
                    }
                    {(document?.eSignVerifyUser && !document?.isIdProofVerified && document?.idProofDetails?.idProofType) && <Grid item xs={12} textAlign={"end"}>
                        <ButtonContained
                            width={"auto"}
                            text={"Fetch Data"}
                            lineHeight={"24.5px"}
                            padding={{ xs: "5px 10px", md: "10px 20px" }}
                            fontSize={{ xs: "12px", md: "14px" }}
                            height={{ xs: "40px", sm: "40px" }}
                            onClick={() => {
                                _id_proof_verification()
                            }}
                        />
                    </Grid>}
                </Grid>
                <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} paddingTop={'2px !important'}>
                        <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Address Details"} />
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Aadhaar Address</InputLabel>
                        <Typography variant="body1">{document?.addressDetails?.aadhaarAddress || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Landmark</InputLabel>
                        <Typography variant="body1">{document?.addressDetails?.landmark || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Area</InputLabel>
                        <Typography variant="body1">{document?.addressDetails?.area || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Pincode</InputLabel>
                        <Typography variant="body1">{document?.addressDetails?.pincode || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>City </InputLabel>
                        <Typography variant="body1">{document?.addressDetails?.city || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>State </InputLabel>
                        <Typography variant="body1">{document?.addressDetails?.state || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Country </InputLabel>
                        <Typography variant="body1">{document?.addressDetails?.country || "N/A"}</Typography>
                    </Grid>
                </Grid>
                {document && !document?.isAddressSameAsAadhaar &&
                    <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12} lg={12} paddingTop={'2px !important'}>
                                    <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Address Proof Details"} />
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <InputLabel className={classes.label}>Address Proof Type</InputLabel>
                                    <Typography variant="body1">{document?.addressProofDetails?.presentAddressProofType || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <InputLabel className={classes.label}>Aadhaar Address </InputLabel>
                                    <Typography variant="body1">{document?.addressProofDetails?.presentAddress || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <InputLabel className={classes.label}>Landmark </InputLabel>
                                    <Typography variant="body1">{document?.addressProofDetails?.presentLandmark || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <InputLabel className={classes.label}>Area </InputLabel>
                                    <Typography variant="body1">{document?.addressProofDetails?.presentArea || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <InputLabel className={classes.label}>Pincode </InputLabel>
                                    <Typography variant="body1">{document?.addressProofDetails?.presentPinCode || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <InputLabel className={classes.label}>City </InputLabel>
                                    <Typography variant="body1">{document?.addressProofDetails?.presentCity || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <InputLabel className={classes.label}>State </InputLabel>
                                    <Typography variant="body1">{document?.addressProofDetails?.presentState || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <InputLabel className={classes.label}>Country </InputLabel>
                                    <Typography variant="body1">{document?.addressProofDetails?.presentCountry || "N/A"}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container item xs={12} sm={12} md={6} lg={6}>
                            <AddressProof
                                data={data}
                                setData={setData}
                                setImagePreView={setImagePreView}
                                handleStatusChange={handleStatusChange}
                                _updateMember={_updateMember}
                                handleInputChange={handleInputChange}
                                setValue={setValue}
                                handleChange={(e) => handleChange({ ...e, section: "otherDocument" })}
                                errors={errors}
                                isEdit={isEdit}
                                setIsEdit={setIsEdit}
                                dataAccess={dataAccess}
                                handleUpload={handleUpload}
                                openAddressProof={openAddressProof}
                                setOpenAddressProof={setOpenAddressProof}
                                document={document}
                            />
                        </Grid>
                    </Grid>
                }

                <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} paddingTop={'2px !important'}>
                        <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Village Details"} />
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Village Name </InputLabel>
                        <Typography variant="body1">{document?.villageDetails?.villageName || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Taluka </InputLabel>
                        <Typography variant="body1">{document?.villageDetails?.taluka || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>District </InputLabel>
                        <Typography variant="body1">{document?.villageDetails?.district || "N/A"}</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12} paddingTop={'2px !important'}>
                        <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Other Details"} />
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Reference Mobile No </InputLabel>
                        <Typography variant="body1">{document?.otherDetails?.referencePersonContactNumber || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Education </InputLabel>
                        <Typography variant="body1">{document?.otherDetails?.education || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Occupation </InputLabel>
                        <Typography variant="body1">{document?.otherDetails?.occupation || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Company Name </InputLabel>
                        <Typography variant="body1">{document?.otherDetails?.companyName || "N/A"}</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                    {document?.nomineeDetails?.map((nominee, index) => (
                        <React.Fragment key={index}>
                            <Grid item xs={12} sm={12} md={12} lg={12} paddingTop={'2px !important'}>
                                <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={`Nominee Detail (${index + 1})`} />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4} lg={3}>
                                <InputLabel className={classes.label}>Relation</InputLabel>
                                <Typography variant="body1">{nominee?.relation || "N/A"}</Typography>
                            </Grid>

                            <Grid item xs={6} sm={6} md={4} lg={3}>
                                <InputLabel className={classes.label}>Nominee Name</InputLabel>
                                <Typography variant="body1">{nominee?.nomineeName || "N/A"}</Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4} lg={3}>
                                <InputLabel className={classes.label}>Contact Number</InputLabel>
                                <Typography variant="body1">{nominee?.contactNumber || "N/A"}</Typography>
                            </Grid>
                        </React.Fragment>
                    ))}
                </Grid>
                {(document?.additionalDocuments?.additionalDocumentType || document?.additionalDocuments?.additionalDocumentProof?.[0] || document?.additionalDocuments?.description) &&
                    <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12} lg={12} paddingTop={'2px !important'}>
                                    <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Additional Document Details"} />
                                </Grid>
                                <Grid item xs={6} sm={6} md={4} lg={3}>
                                    <InputLabel className={classes.label}>Additional Document Type</InputLabel>
                                    <Typography variant="body1">{document?.additionalDocuments?.additionalDocumentType || "N/A"}</Typography>
                                </Grid>
                                <Grid item xs={6} sm={6} md={4} lg={3}>
                                    <InputLabel className={classes.label}>Additional Document Proof</InputLabel>
                                    <Avatar src={getImageUrl(document?.additionalDocuments?.additionalDocumentProof?.[0])} alt="image" sx={{ cursor: 'pointer' }}
                                        slotProps={{
                                            loading: "lazy",
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => setPreview({ open: true, link: getImageUrl(document?.additionalDocuments?.additionalDocumentProof?.[0]), fileName: document?.additionalDocuments?.additionalDocumentProof })}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={6} md={4} lg={3}>
                                    <InputLabel className={classes.label}>Description </InputLabel>
                                    <Typography variant="body1">{document?.additionalDocuments?.description || "N/A"}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                    <FinalizeDocuments
                        data={data}
                        handleStatusChange={handleStatusChange}
                        _updateMember={_updateMember}
                        validation={validation}
                        errors={errors}
                        dataAccess={dataAccess}
                    />
                </Grid>
            </Box>
            {preview?.open && (
                <Dialog open={preview?.open} onClose={() => setPreview({ open: false, link: "", fileName: "" })} fullWidth={true}>
                    <DialogTitle sx={{ padding: "8px 16px" }}>
                        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} >
                            <Typography fontSize={"15px"} fontWeight={700} color={theme.palette.primary.main}>
                                Preview
                            </Typography>
                            <Box display={'flex'} gap={1} justifyContent={'space-between'} alignItems={'center'} >
                                <CloseIcon onClick={() => setPreview({ open: false, link: "", fileName: "" })} style={{ cursor: 'pointer' }} />
                            </Box>
                        </Box>
                    </DialogTitle>

                    <DialogContent>
                        <DocPreview
                            link={preview?.link}
                            iconName={getFileIcon(preview?.fileName, preview?.fileName[0])}  // Passing originalDocArray and fileName
                            octateFile={false}
                        />
                    </DialogContent>

                </Dialog>
            )}

        </Grid >
    );
};

const renderIDProof = (type, classes, data) => {
    return (
        type === "PAN Card" ?
            <>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <InputLabel className={classes.label}>Full Name</InputLabel>
                    <Typography variant="body1">{data?.name || "N/A"}</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <InputLabel>Gender</InputLabel>
                    <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>{data?.gender || "N/A"}</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <InputLabel className={classes.label}>Date of Birth</InputLabel>
                    <Typography variant="body1">{data?.date_of_birth ? dayjs(data?.date_of_birth).format("DD MMM YYYY") : "N/A"}</Typography>
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={3}>
                    <InputLabel className={classes.label}>Masked Aadhaar Number</InputLabel>
                    <Typography variant="body1">{data?.masked_aadhaar_number || "N/A"}</Typography>
                </Grid>
            </>
            : type === "Voter ID Card" ?
                <>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Full Name</InputLabel>
                        <Typography variant="body1">{data?.name || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Father Name</InputLabel>
                        <Typography variant="body1">{data?.father_name || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Gender</InputLabel>
                        <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>{data?.gender || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>Date of Birth</InputLabel>
                        <Typography variant="body1">{data?.date_of_birth ? dayjs(data?.date_of_birth).format("DD MMM YYYY") : "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>State</InputLabel>
                        <Typography variant="body1">{data?.state || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                        <InputLabel className={classes.label}>District</InputLabel>
                        <Typography variant="body1">{data?.district || "N/A"}</Typography>
                    </Grid>
                </>
                : type === "Passport" ?
                    <>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <InputLabel>First Name</InputLabel>
                            <Typography variant="body1">{data?.first_name || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <InputLabel>Issue Date</InputLabel>
                            <Typography variant="body1">{data?.issue_date ? dayjs(data?.issue_date).format("DD MMM YYYY") : "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <InputLabel>Date of Birth</InputLabel>
                            <Typography variant="body1">{data?.date_of_birth ? dayjs(data?.date_of_birth).format("DD MMM YYYY") : "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <InputLabel>document ID</InputLabel>
                            <Typography variant="body1">{data?.document_id || "N/A"}</Typography>
                        </Grid>
                    </>
                    :
                    <>
                        <Grid item xs={6} sm={6} md={4} lg={3}>
                            <InputLabel className={classes.label}>Full Name</InputLabel>
                            <Typography variant="body1">{data?.name || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={4} lg={3}>
                            <InputLabel className={classes.label}>Father Name</InputLabel>
                            <Typography variant="body1">{data?.dependent_name || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={4} lg={3}>
                            <InputLabel className={classes.label}>Date of Birth</InputLabel>
                            <Typography variant="body1">{data?.date_of_birth ? dayjs(data?.date_of_birth).format("DD MMM YYYY") : "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={4} lg={3}>
                            <InputLabel className={classes.label}>Address</InputLabel>
                            <Typography variant="body1">{data?.address || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={4} lg={3}>
                            <InputLabel className={classes.label}>Pincode</InputLabel>
                            <Typography variant="body1">{data?.pincode || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} md={4} lg={3}>
                            <InputLabel className={classes.label}>Blood Group</InputLabel>
                            <Typography variant="body1">{data?.blood_group || "N/A"}</Typography>
                        </Grid>
                    </>
    )
}

export default DocumentsView;
